import { FC, ReactNode } from 'react'
import {
  SBDynamicFormStep,
  SBDynamicFormStepType,
} from './partial/SBDynamicFormStep'

const SBDynamicForm: FC & SBDynamicFormStepType = (): ReactNode => <></>

SBDynamicForm.Step = SBDynamicFormStep

export default SBDynamicForm
